module.exports = __webpack_public_path__ + "static/screen-1@3x-3cee57b8e34572b4d6ab6733e5e90756.png";